import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import './utils/flexible'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as Icons from '@element-plus/icons-vue'
import zhCN from './locale/zh-CN'
import enUS from './locale/en-US'

// 忽略 ResizeObserver 循环错误（Element Plus 常见问题，不影响功能）
const origError = console.error
console.error = function(...args) {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) return
  origError.apply(console, args)
}
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation()
  }
}, true)
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation()
  }
}, true)

// 强制默认中文，清除缓存以重置
if (!localStorage.getItem('lang')) {
  localStorage.setItem('lang', 'zh-CN')
}

const i18n = createI18n({
  locale: localStorage.getItem('lang') || 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

const app = createApp(App)
app.use(router)
app.use(i18n)
app.use(ElementPlus)

app.config.globalProperties.formatDate = (dateStr) => {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  if (isNaN(d.getTime())) return dateStr
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

Object.keys(Icons).forEach(key => {
  app.component(key, Icons[key])
})

app.mount('#app')